import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ProfileChooseService {
  private profileChooseSubject = new BehaviorSubject(null);

  constructor() { }

  setNewProfile(profile) {
    this.profileChooseSubject.next(profile);
  }

  getProfile() {
    return this.profileChooseSubject.asObservable();
  }

}
